import { render, staticRenderFns } from "./TheItem.vue?vue&type=template&id=f4fc0de2&scoped=true"
import script from "./TheItem.vue?vue&type=script&lang=js"
export * from "./TheItem.vue?vue&type=script&lang=js"
import style0 from "./TheItem.vue?vue&type=style&index=0&id=f4fc0de2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4fc0de2",
  null
  
)

export default component.exports